import { createContext, useContext, useState, FC, ReactNode } from "react";

import {
  IContextReportAniversariantes,
  IDataAniversariantes,
  IFilterAniversariantes,
} from "./ContextReportAniversariantesTypes";
import {
  valuesDefaultFilterAniversariantes,
} from "./ValuesDefaultContextProfile/ValuesDefaultContextReportAniversariantes";

const ContextReportAniversariantesProvider = createContext({} as IContextReportAniversariantes);

const ReportAniversariantesProviderContext: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [filterAniversariantes, setFilterAniversariantes] =
    useState<IFilterAniversariantes>(valuesDefaultFilterAniversariantes);

  const [dataAniversariantes, setDataAniversariantes] =
    useState<IDataAniversariantes>({ data: [], total: 0 });

  return (
    <ContextReportAniversariantesProvider.Provider
      value={{
        setFilterAniversariantes,
        setDataAniversariantes,
        filterAniversariantes,
        dataAniversariantes,
      }}
    >
      {children}
    </ContextReportAniversariantesProvider.Provider>
  );
};

const useContextReportAniversariantes = (): IContextReportAniversariantes =>
  useContext(ContextReportAniversariantesProvider);

export {
  useContextReportAniversariantes,
  ReportAniversariantesProviderContext,
};
